import { HttpClient } from "@angular/common/http";
import { UrlServidor } from "../util/url-servidor";
import { VerificarUsuario } from "../api/dto/verificar-usuario";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
  })
  export class VerificarUsuarioService {
  
    constructor(private http: HttpClient) { }
  
    private url : string = UrlServidor.URL_BASE + 'verificar-usuarios';
  
  
    buscarPorId(id?: string): Observable<VerificarUsuario> {
      return this.http.get<VerificarUsuario>(this.url + '/' + id);
    }
    
  }